export const GROWTH_CHEAP_VARIANT = 'Growth - Variant 1';
export const GROWTH_EXPENSIVE_VARIANT = 'Growth - Variant 2';
export const PAYG = 'PAYG';
export const PAYG_30_LABEL_LIMIT = 'PAYG 30 Label Limit';
const PRO_200 = 'Pro 200';

export const PRO_PLAN = PRO_200;
export const STARTER_PLAN = PAYG_30_LABEL_LIMIT;
